import { apiClient } from '~/lib/apiClient';

export type FetchOrderId = [string, string];
export const fetchOrderId = async ([orderId, token]: FetchOrderId) => {
  const response = await apiClient.v1.orders._orderId(orderId).get({
    headers: { Authorization: `Bearer ${token}` },
  });
  return { body: response.body, statusCode: response.status };
};
